import {
  Box,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

import { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';

interface ViewStep3Props {
  formData: IComunidadesRuraisTradicionais;
}

export const ViewStep3: React.FC<ViewStep3Props> = ({
  formData,
}) => {
  const formatBooleanValue = (value: boolean | null) => {
    if (value === null || value === undefined) return '';
    return value ? 'Sim' : 'Não';
  };

  const getFonteAguaLabel = (value: number | null) => {
    if (!value) return '';

    const fontesAgua = [
      { value: 1, label: 'Córrego' },
      { value: 2, label: 'Rio ou outro curso d\'água' },
      { value: 3, label: 'Poço comum' },
      { value: 4, label: 'Poço artesiano ou semi-artesiano' },
      { value: 5, label: 'Captação da chuva' },
      { value: 6, label: 'Água potável de órgão/companhia de abastecimento' },
    ];

    return fontesAgua.find(fonte => fonte.value === value)?.label ?? '';
  };

  // Verificar se é assentamento ou comunidade quilombola
  const isAssentamento = formData.tipo_cadastro === 1;
  const isComunidadeQuilombola = formData.tipo_cadastro === 2;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant='h5'
        gutterBottom
        sx={{ fontWeight: 'bold', mb: 4 }}
      >
        Serviços Ambientais
      </Typography>

      {/* Água para Abastecimento Doméstico */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui água para abastecimento doméstico (consumo da família)?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_agua_para_abastecimento_domestico)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Fonte da água doméstica - só aparece se 14 for Sim */}
      {formData.possui_agua_para_abastecimento_domestico === true && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Qual a fonte?
            </Typography>
            <TextField
              fullWidth
              value={getFonteAguaLabel(formData.qual_fonte_da_agua_domestico)}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>
        </Grid>
      )}

      {/* Água para Produção Agropecuária */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui água para a produção agropecuária?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_agua_para_producao_agropecuaria)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Fonte da água para produção - só aparece se 16 for Sim */}
      {formData.possui_agua_para_producao_agropecuaria === true && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Qual a fonte?
            </Typography>
            <TextField
              fullWidth
              value={getFonteAguaLabel(formData.qual_fonte_da_producao_agropecuaria)}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>
        </Grid>
      )}

      {/* Perguntas específicas para Assentamentos */}
      {isAssentamento && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Quantas famílias estão sem acesso ou com acesso precário à água para abastecimento doméstico?
            </Typography>
            <TextField
              fullWidth
              value={formData.quantas_familia_estao_sem_acesso_agua_domestico?.toString() ?? ''}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              Quantas famílias estão sem acesso ou com acesso precário à água para produção?
            </Typography>
            <TextField
              fullWidth
              value={formData.quantas_familia_estao_sem_acesso_agua_producao?.toString() ?? ''}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>
        </Grid>
      )}

      {/* Perguntas específicas para Comunidades Quilombolas */}
      {isComunidadeQuilombola && (
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              A comunidade quilombola tem dificuldade no acesso à água para abastecimento doméstico?
            </Typography>
            <TextField
              fullWidth
              value={formatBooleanValue(formData.comunidade_quilomba_tem_dificil_acesso_agua_domestico)}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
              A comunidade quilombola tem dificuldade no acesso à água para produção?
            </Typography>
            <TextField
              fullWidth
              value={formatBooleanValue(formData.comunidade_quilomba_tem_dificil_acesso_agua_producao)}
              InputProps={{
                readOnly: true,
                sx: { backgroundColor: '#f5f5f5' },
              }}
            />
          </Grid>
        </Grid>
      )}


    </Box>
  );
};
